import { Fragment } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { addFilter } from '@wordpress/hooks';
import { MergeFields, MergeFieldset } from './merge-fields';

function Modal( content, clientId, action, updateSettings ) {

	const fields = [{
		label: 'Name',
		name: 'user_login',
		help: __( 'The user name. If you leave this blank, email field will be used.', 'popper' )
	},{
		label: 'Email',
		name: 'user_email',
		help: __( 'The user email.', 'popper' )
	},{
		label: 'First name',
		name: 'first_name',
		help: __( 'The user first name. This is not required.', 'popper' )
	},{
		label: 'Last name',
		name: 'last_name',
		help: __( 'The user last name. This is not required.', 'popper' )
	}]

	return (
		<Fragment>
			<p>{ __( 'This action will add a user to WordPress. Map the fields below to form fields.' ) }</p>
			<MergeFieldset
				action={ action }
				clientId={ clientId }
				fields={ fields }
				updateSettings={ updateSettings }
			/>
		</Fragment>
	);
}

addFilter( 'popper.modal.Subscribe', 'popper/subscribe', Modal, 3 );
